/* PawsOn 2026 — product detail page.

   Three things drive the buy box: which pack, one-time or subscription, and
   which delivery frequency. Every price on the page recomputes from those,
   including the button label, which carries the decision.

   No money is formatted here. Liquid renders every price a variant or plan
   could show and this file swaps the strings, so the page can never disagree
   with the shop's own currency format.

   The section is self-contained: everything is looked up inside its root, so
   more than one can sit on a page without interfering. */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pwReady === 'true') return;
    root.dataset.pwReady = 'true';

    var dataEl = root.querySelector('[data-pw-variants]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = data.variants || [];
    if (!variants.length) return;

    var $ = function (sel) { return root.querySelector(sel); };

    var variantInput = $('[data-pw-variant-input]');
    var planInput = $('[data-pw-plan-input]');
    var priceEl = $('[data-pw-price]');
    var suffixEl = $('[data-pw-suffix]');
    var noteEl = $('[data-pw-note]');
    var stockEl = $('[data-pw-stock]');
    var atc = $('[data-pw-atc]');
    var atcLabel = $('[data-pw-atc-label]');
    var freqSelect = $('[data-pw-freq]');
    var modePriceOne = $('[data-pw-mode-price-onetime]');
    var modePriceSub = $('[data-pw-mode-price-sub]');
    var barPrice = $('[data-pw-bar-price]');
    var barSub = $('[data-pw-bar-sub]');
    var barBtn = $('[data-pw-bar-btn]');

    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-pw-pack]'));
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-pw-modes] input'));

    function find(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    var state = {
      variant: find(variantInput ? variantInput.value : variants[0].id),
      mode: 'onetime',
      planId: freqSelect ? freqSelect.value : null
    };

    function planFor(variant) {
      if (!variant.plans || !variant.plans.length) return null;
      for (var i = 0; i < variant.plans.length; i++) {
        if (String(variant.plans[i].id) === String(state.planId)) return variant.plans[i];
      }
      return variant.plans[0];
    }

    /* Selection is instant and carries no transition. Animating it makes the
       previously chosen row read as still chosen part way through. */
    function markChosen(inputs, className) {
      inputs.forEach(function (input) {
        var label = input.closest('label');
        if (label) label.classList.toggle(className, input.checked);
      });
    }

    function render() {
      var v = state.variant;
      var plan = state.mode === 'subscribe' ? planFor(v) : null;
      var subscribing = !!plan;

      if (variantInput) variantInput.value = v.id;

      if (planInput) {
        if (subscribing) {
          planInput.value = plan.id;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }

      if (priceEl) priceEl.textContent = subscribing ? plan.priceText : v.priceText;
      if (suffixEl) suffixEl.textContent = subscribing ? plan.suffix : 'one time';

      /* A comparison, not a percentage: a 10% plan on a 36p unit rounds to
         4p, which reads back as 11% and contradicts the plan's own name. */
      if (noteEl) {
        if (subscribing) {
          noteEl.textContent = 'Subscription price, down from ' + v.priceText;
          noteEl.hidden = false;
        } else {
          noteEl.hidden = true;
        }
      }

      if (modePriceOne) modePriceOne.textContent = v.priceText;
      if (modePriceSub) {
        var subPlan = planFor(v);
        if (subPlan) modePriceSub.textContent = subPlan.priceText;
      }

      if (stockEl) {
        stockEl.hidden = false;
        if (!v.available) {
          stockEl.textContent = 'Out of stock';
          stockEl.classList.add('pw-price__stock--out');
        } else {
          stockEl.classList.remove('pw-price__stock--out');
        }
      }

      if (atc) atc.disabled = !v.available;
      if (atcLabel) {
        if (!v.available) {
          atcLabel.textContent = 'Sold out';
        } else if (subscribing) {
          atcLabel.textContent = 'Subscribe, ' + plan.priceText;
        } else {
          atcLabel.textContent = 'Add to basket, ' + v.priceText;
        }
      }

      if (barPrice) barPrice.textContent = subscribing ? plan.priceText : v.priceText;
      if (barSub && suffixEl) barSub.textContent = subscribing ? plan.suffix : 'one time';

      /* The bar is the button once the buy box has gone, so it has to carry
         the same decision the real one does. */
      if (barBtn) {
        barBtn.disabled = !v.available;
        barBtn.textContent = !v.available ? 'Sold out' : subscribing ? 'Subscribe' : 'Add to basket';
      }

      /* Every row, not just the chosen one: the whole ladder is priced in
         whichever mode is selected, otherwise the pack you are not on quotes
         a figure you would not be charged. */
      variants.forEach(function (row) {
        var rowPlan = state.mode === 'subscribe' ? planFor(row) : null;
        var unitEl = root.querySelector('[data-pw-pack-unit="' + row.id + '"]');
        var totalEl = root.querySelector('[data-pw-pack-total="' + row.id + '"]');
        if (unitEl) unitEl.textContent = (rowPlan ? rowPlan.unitText : row.unitText) + ' each';
        if (totalEl) totalEl.textContent = rowPlan ? rowPlan.priceText : row.priceText;
      });

      markChosen(packs, 'pw-pack--on');
      markChosen(modes, 'pw-mode--on');
    }

    packs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        state.variant = find(input.value);
        render();
        updateUrl(input.value);
      });
    });

    modes.forEach(function (input) {
      input.addEventListener('change', function () {
        state.mode = input.value;
        render();
      });
    });

    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        state.planId = freqSelect.value;
        render();
      });
      /* Choosing a frequency is choosing to subscribe. */
      freqSelect.addEventListener('click', function (event) { event.stopPropagation(); });
    }

    /* --- Gallery ---------------------------------------------------------
       Every image is already in the plate, so a thumbnail only decides which
       one is shown. Nothing loads on click and the plate never reflows. */

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pw-thumb]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('.pw-pdp__img'));

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        images.forEach(function (img, i) {
          img.classList.toggle('pw-pdp__img--on', i === index);
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('pw-pdp__thumb--on', i === index);
        });
      });
    });

    /* --- Quantity ------------------------------------------------------- */

    var qtyInput = $('[data-pw-qty-input]');
    root.querySelectorAll('[data-pw-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.pwQty, 10);
        qtyInput.value = next < 1 ? 1 : next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* --- Address bar ----------------------------------------------------
       Keeps the URL shareable and the back button honest without a reload. */

    function updateUrl(id) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    }

    /* --- Mobile bar ------------------------------------------------------
       Appears once the buy box has scrolled past, which on a phone is most of
       the page. The button drives the real submit so the cart drawer, error
       handling and selling plan all behave identically. */

    var buybox = $('[data-pw-buybox]');
    var bar = $('[data-pw-stickybar]');

    if (bar && buybox) {
      /* A plain scroll check rather than an IntersectionObserver. A collapsed
         root margin makes the observer's behaviour depend on how the scroll
         happened, and it missed programmatic jumps; comparing the buy box's
         own bottom edge is unambiguous. */
      var pending = false;

      var sync = function () {
        pending = false;
        var past = buybox.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('pw-stickybar--on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      };

      var onScroll = function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(sync);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    }

    if (barBtn && atc) {
      barBtn.addEventListener('click', function () {
        atc.click();
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-pw-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders a section into new DOM on every change. */
  document.addEventListener('shopify:section:load', boot);
})();
